// Flat marketing fees for the buyer payment-method selection screen.
// Sourced from product (validated with 9 of 11 UserTesting participants on $48 digital).
// Not per-request — if pricing ever becomes dynamic, promote these to the BFF payload.
export const DIGITAL_PAYMENT_FEE_USD = 48;
export const WIRE_FEE_ESTIMATE_USD = 35;
export const DIGITAL_VS_WIRE_DELTA_USD = DIGITAL_PAYMENT_FEE_USD - WIRE_FEE_ESTIMATE_USD;

export enum PaymentMethodChoice {
    Digital = 'Digital',
    Wire = 'Wire',
}
